import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'

const BankListModal = ({
  show,
  onHide,
  loadingBanks,
  bankAccounts,
  showAddForm,
  setShowAddForm,
  bankForm,
  setBankForm,
  formError,
  setFormError,
  submittingBank,
  handleAddBankAccount,
  handleDeleteBankAccount
}) => {
  return (
    <Modal
      show={show}
      onHide={() => {
        onHide()
        setShowAddForm(false)
        setFormError('')
      }}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: '1.2em', fontWeight: 'bold', color: '#00a651' }}>
          Daftar Rekening Bank
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loadingBanks ? (
          <div style={{ textAlign: 'center', padding: '20px 0', color: '#666' }}>
            Memuat daftar rekening...
          </div>
        ) : (
          <>
            {bankAccounts.length === 0 && !showAddForm && (
              <div style={{ textAlign: 'center', padding: '20px 0', color: '#888' }}>
                Belum ada rekening bank yang tersimpan.
              </div>
            )}

            {bankAccounts.map((account) => (
              <div
                key={account.id}
                style={{
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  padding: '14px 18px',
                  marginBottom: '12px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  backgroundColor: '#fbfbfb'
                }}
              >
                <div>
                  <span style={{
                    display: 'inline-block',
                    backgroundColor: '#00a651',
                    color: '#fff',
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    marginBottom: '6px',
                    textTransform: 'uppercase'
                  }}>
                    {account.bank_name}
                  </span>
                  <h4 style={{ margin: '2px 0', fontSize: '1em', fontWeight: 'bold', color: '#333' }}>
                    {account.account_number}
                  </h4>
                  <span style={{ fontSize: '0.85em', color: '#666' }}>
                    a.n {account.account_holder_name}
                  </span>
                </div>
                <button
                  type="button"
                  onClick={() => handleDeleteBankAccount(account.id)}
                  style={{
                    background: '#fff',
                    border: '1px solid #dc3545',
                    color: '#dc3545',
                    padding: '6px 12px',
                    borderRadius: '6px',
                    fontSize: '0.85em',
                    cursor: 'pointer',
                    outline: 'none',
                    fontWeight: '600'
                  }}
                >
                  Hapus
                </button>
              </div>
            ))}

            {!showAddForm ? (
              <button
                type="button"
                onClick={() => setShowAddForm(true)}
                style={{
                  width: '100%',
                  padding: '10px',
                  marginTop: '10px',
                  border: '1px dashed #00a651',
                  borderRadius: '6px',
                  backgroundColor: '#e6f7ed',
                  color: '#00a651',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  outline: 'none'
                }}
              >
                + Tambah Rekening Baru
              </button>
            ) : (
              <form onSubmit={handleAddBankAccount} style={{ marginTop: '15px', padding: '16px', border: '1px solid #ddd', borderRadius: '8px', backgroundColor: '#fff' }}>
                <h4 style={{ margin: '0 0 12px 0', fontSize: '1em', fontWeight: 'bold', color: '#333' }}>
                  Tambah Rekening Bank Baru
                </h4>

                {formError && (
                  <div style={{ color: '#dc3545', fontSize: '0.85em', marginBottom: '10px' }}>
                    {formError}
                  </div>
                )}

                <div style={{ marginBottom: '12px' }}>
                  <label style={{ display: 'block', fontSize: '0.85em', fontWeight: 'bold', color: '#555', marginBottom: '4px' }}>
                    Nama Bank
                  </label>
                  <input
                    type="text"
                    placeholder="Contoh: BCA, Mandiri, BRI, BNI"
                    value={bankForm.bank_name}
                    onChange={(e) => setBankForm({ ...bankForm, bank_name: e.target.value })}
                    style={{ width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #ccc', outline: 'none' }}
                    required
                  />
                </div>

                <div style={{ marginBottom: '12px' }}>
                  <label style={{ display: 'block', fontSize: '0.85em', fontWeight: 'bold', color: '#555', marginBottom: '4px' }}>
                    Nama Pemilik Rekening
                  </label>
                  <input
                    type="text"
                    placeholder="Nama sesuai rekening"
                    value={bankForm.account_holder_name}
                    onChange={(e) => setBankForm({ ...bankForm, account_holder_name: e.target.value })}
                    style={{ width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #ccc', outline: 'none' }}
                    required
                  />
                </div>

                <div style={{ marginBottom: '14px' }}>
                  <label style={{ display: 'block', fontSize: '0.85em', fontWeight: 'bold', color: '#555', marginBottom: '4px' }}>
                    Nomor Rekening
                  </label>
                  <input
                    type="text"
                    placeholder="Nomor rekening bank"
                    value={bankForm.account_number}
                    onChange={(e) => setBankForm({ ...bankForm, account_number: e.target.value })}
                    style={{ width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #ccc', outline: 'none' }}
                    required
                  />
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                  <button
                    type="button"
                    onClick={() => { setShowAddForm(false); setFormError(''); }}
                    style={{ padding: '8px 16px', borderRadius: '6px', border: '1px solid #ccc', background: '#fff', color: '#555', cursor: 'pointer', outline: 'none' }}
                  >
                    Batal
                  </button>
                  <button
                    type="submit"
                    disabled={submittingBank}
                    style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', background: '#00a651', color: '#fff', fontWeight: 'bold', cursor: 'pointer', outline: 'none' }}
                  >
                    {submittingBank ? 'Menyimpan...' : 'Simpan Rekening'}
                  </button>
                </div>
              </form>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  )
}

BankListModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  loadingBanks: PropTypes.bool.isRequired,
  bankAccounts: PropTypes.array.isRequired,
  showAddForm: PropTypes.bool.isRequired,
  setShowAddForm: PropTypes.func.isRequired,
  bankForm: PropTypes.object.isRequired,
  setBankForm: PropTypes.func.isRequired,
  formError: PropTypes.string,
  setFormError: PropTypes.func.isRequired,
  submittingBank: PropTypes.bool.isRequired,
  handleAddBankAccount: PropTypes.func.isRequired,
  handleDeleteBankAccount: PropTypes.func.isRequired
}

export default BankListModal
